import { useLazyQuery } from '@apollo/client';

import GetRolesByIds from 'bundles/onboarding-common/queries/GetRolesByIds.graphql';
import type {
  GetRolesByIdsQuery,
  GetRolesByIdsQueryVariables,
} from 'bundles/onboarding-common/queries/__generated__/GetRolesByIds';

const useGetRolesByIds = () => {
  const [getRolesByIds] = useLazyQuery<GetRolesByIdsQuery, GetRolesByIdsQueryVariables>(GetRolesByIds, {
    errorPolicy: 'all',
    context: {
      clientName: 'gatewayGql',
    },
  });

  return {
    getRolesByIds,
  };
};

export default useGetRolesByIds;
